import React, { useContext } from "react";
import PropTypes from "prop-types";

import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import { Hidden, InputBase, Paper, Menu, MenuItem } from "@material-ui/core";
import { useState, useEffect, useRef, useCallback } from "react";
import { AdvanceSearch } from "./AdvanceSearch";

import SearchIcon from "@material-ui/icons/Search";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import MoreIcon from "@material-ui/icons/MoreVert";
import ClearAllIcon from "@material-ui/icons/ClearAll";
import FilterListIcon from "@material-ui/icons/FilterList";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { RecruitmentContext } from "../../../../context/states/recruitmentState";

import {
  Grid,
  Toolbar,
  Typography,
  Tooltip,
  IconButton,
} from "@material-ui/core";

import EmailIcon from "@material-ui/icons/Email";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import RefreshIcon from "@material-ui/icons/Refresh";

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },

  paperRoot: {
    width: 650,
    maxWidth: "100%",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(2),
    marginLeft: theme.spacing(4),
  },
  minPaperRoot: {
    width: 400,
    maxWidth: "100%",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  advanceCard: {
    margin: theme.spacing(0.4, 0),
    marginLeft: theme.spacing(4),
    padding: theme.spacing(1),
    position: "absolute",
    width: 650,
    minWidth: 650,
    overflow: "auto",
    zIndex: 3,
    [theme.breakpoints.up("sm")]: {
      maxWidth: "50%",
    },
  },

  title: {
    flex: "1 1 100%",
  },

  listCount: {
    fontSize: "12px",
    fontWeight: 600,
    padding: "4px 8px",
    borderRadius: "4px",
    color: theme.palette.text.disabled,
    backgroundColor: lighten(theme.palette.action.disabled, 0.9),
  },
  advanceCard: {
    margin: theme.spacing(0.4, 0),
    marginLeft: theme.spacing(4),
    padding: theme.spacing(1),
    position: "absolute",
    width: 650,
    minWidth: 650,
    overflow: "auto",
    zIndex: 3,
    [theme.breakpoints.up("sm")]: {
      maxWidth: "50%",
    },
  },

  duplicateToggleOff: {
    color: "#9e9e9e",
  },

  duplicateToggleLabelOff: {
    color: "#9e9e9e",
    cursor: "pointer",
    userSelect: "none",
  },
}));

export const TableToolbar = (props) => {
  const classes = useToolbarStyles();
  const {
    numSelected,
    tableTitle,
    listCount,
    isCheckbox,
    isEnable,
    handleRefresh,
    handleCheckbox,
    setIsSearchObj,
    isSearchObj,
    clearAdvancedSearchHandler,
    filterOptions,
    filterHandler,
    handleFormModal,
  } = props;

  const { isLanguages, isDialects, getLangugagesHandler, getDialectsHandler } =
    useContext(RecruitmentContext);

  const [isMinimize, setIsMinimize] = useState(false);
  const minimizeHandler = () => setIsMinimize(!isMinimize);
  const [isOpen, setIsOpen] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const advancedToggleHandler = () => {
    setIsOpen(true);
  };
  const closeAdvanceModelHandler = () => {
    setIsOpen(false);
  };
  const [filterActive, setFilterActive] = useState(null);
  const handleFilterOpen = (event) => setFilterActive(event.currentTarget);
  const handleFilterClose = (event) => setFilterActive(null);

  const [isMenuList, setIsMenuList] = useState(null);
  const handleMenuList = (event) => setIsMenuList(event.currentTarget);
  const handleMenuListClose = () => setIsMenuList(null);
  const inputSearchRef = useRef();

  useEffect(() => {
    if (localStorage.getItem("baSearch") !== null) {
      setIsMinimize(true);
    }
    let unmounted = false;

    if (!unmounted) {
      getLangugagesHandler();
      getDialectsHandler();
    }

    return () => {
      unmounted = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const clickToSearchHandler = useCallback(
    (event) => {
      var code = event.key;
      setIsSearching(false);

      if (code === "Enter") {
        event.preventDefault();
        setTimeout(() => {
          setIsSearchObj((prev) => ({
            ...prev,
            name: inputSearchRef.current?.value,
          }));
        }, 1000);
      }
    },
    [isSearchObj],
  );

  const clearMainSearchHandler = useCallback(() => {
    inputSearchRef.current.value = "";
    setIsSearchObj((prev) => ({
      ...prev,
      name: "",
    }));
    setIsSearching(false);
  }, [setIsSearchObj]);

  const handleDuplicateToggle = useCallback(() => {
    setIsSearchObj((prev) => ({
      ...prev,
      hasDuplicates: !prev.hasDuplicates,
      page: 1,
    }));
  }, [setIsSearchObj]);

  return (
    <Toolbar>
      <Grid container justify="space-between" alignItems="center">
        {/* TITLE */}
        <Grid item>
          <Typography variant="h6">
            {tableTitle} |<span className={classes.listCount}>{listCount}</span>
          </Typography>
        </Grid>

        {/* ADVANCED SEARCH */}
        <React.Fragment>
          {/* Search bar */}
          <Grid item>
            <Hidden only={["sm", "xs"]}>
              <Paper component="form" className={classes.paperRoot}>
                <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="center"
                >
                  <Grid item md={1} className={classes.sectionDesktop}>
                    <IconButton aria-label="search">
                      <SearchIcon />
                    </IconButton>
                  </Grid>
                  <Grid item md={10}>
                    <InputBase
                      placeholder="Search"
                      style={{ width: "100%" }}
                      inputProps={{ "aria-label": "search" }}
                      inputRef={inputSearchRef}
                      defaultValue={isSearchObj?.sn}
                      onKeyPress={clickToSearchHandler}
                    />
                  </Grid>
                  <Grid item md={1}>
                    {isSearching ? (
                      <Tooltip title="Clear search">
                        <IconButton
                          aria-label="maximize modal"
                          color="primary"
                          onClick={clearMainSearchHandler}
                        >
                          <ClearAllIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <IconButton
                        aria-label="search"
                        onClick={advancedToggleHandler}
                      >
                        <ArrowDropDownIcon />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              </Paper>
              {/* Advance search */}
              {isOpen && (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <AdvanceSearch
                    classes={classes}
                    handleToggle={closeAdvanceModelHandler}
                    clearAdvancedSearchHandler={clearAdvancedSearchHandler}
                    isLanguages={isLanguages}
                    isDialects={isDialects}
                    isMinimize={isMinimize}
                    handleMinimize={minimizeHandler}
                    setIsSearchObj={setIsSearchObj}
                    isSearchObj={isSearchObj}
                    setIsSearching={setIsSearching}
                  />
                </MuiPickersUtilsProvider>
              )}
            </Hidden>
          </Grid>
          {/* Right action */}
          <Grid item>
            <Grid container alignItems="center">
              {/* SHOW DUPLICATES */}
              <Tooltip
                title={
                  isSearchObj?.hasDuplicates
                    ? "Hide duplicates"
                    : "Show duplicates"
                }
              >
                <IconButton
                  color={isSearchObj?.hasDuplicates ? "primary" : "default"}
                  onClick={handleDuplicateToggle}
                  aria-label="show duplicates"
                  className={
                    !isSearchObj?.hasDuplicates
                      ? classes.duplicateToggleOff
                      : ""
                  }
                >
                  {isSearchObj?.hasDuplicates ? (
                    <ToggleOnIcon />
                  ) : (
                    <ToggleOffIcon />
                  )}
                </IconButton>
              </Tooltip>

              <Typography
                variant="body2"
                className={
                  !isSearchObj?.hasDuplicates
                    ? classes.duplicateToggleLabelOff
                    : ""
                }
                onClick={handleDuplicateToggle}
              >
                Show Duplicates
              </Typography>

              {/* REFRESH */}
              <Tooltip title="Refresh">
                <IconButton color="primary" onClick={handleRefresh}>
                  <RefreshIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </React.Fragment>
      </Grid>
    </Toolbar>
  );
};

TableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  handleRefresh: PropTypes.func,
  handleCheckbox: PropTypes.func,
};
